module.exports = __webpack_public_path__ + "img/customer9.c756bf9d.png";